import { useFetchAuthToken } from 'features/auth/hooks/useFetchAuthToken';
import { useFetchStudyHistory } from 'features/optimization/hooks/useFetchStudyHistory';
import { useFetchS3Objects } from 'features/file-browser/hooks/useFetchS3Objects';
import { useFetchCFDHistory } from 'features/cfd/hooks/useFetchCFDHistory';
import { useFetchPriceSummary } from 'features/price-summary/hooks/useFetchPriceSummary';
import { useFetchErrorCodes } from 'features/error-codes/hooks/useFetchErrorCodes';

export const InitialFetch = () => {
    useFetchAuthToken();
    useFetchStudyHistory();
    useFetchCFDHistory();
    useFetchS3Objects();
    useFetchPriceSummary();
    useFetchErrorCodes();
    return null;
};
